/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import {
  DivIcon,
  LayerGroup, LeafletEvent, Marker,
  markerClusterGroup,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IModalData } from '@/services/layers/IModalData';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';
import MapIconsGeneratorService from '../MapIconsGeneratorService';
import { toRaw } from 'vue';

export default class RadarBoardsLayerService extends LayerService {
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const modalIconUrl = require(`@/assets/img/icon-layers/single-icons/marker_radar.svg`);

    // const dateTimes = metaData.parking_boards
    //   .filter((board: any) => board.last_status && board.last_status.date_time)
    //   .map((board: any) => board.last_status?.date_time);

    // let newestDate: string = '';

    // if (dateTimes.length > 0) {
    //   newestDate = new Date(Math.max(...dateTimes.map((dt: string) => new Date(dt)))).toString();
    // }

    const modalData: IModalData = {
      title: metaData.name,
      content: '',
      navigationPoint: undefined,
      lastUpdate: metaData.last_status.date_time || '',
      icon: modalIconUrl,
      templateName: 'TemplateModalRadarBoard',
      metaData: metaData,
      iconClassName: '',
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.radarBoards;
    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  generateClusterHtml(population: number) {
    const settings: IClusterIconSettings = {
      className: 'g__color--parking',
      insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_radar.svg`),
      population,
    };
    const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
    
    return iconHtml;
  }

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const settings: IMarkerIconSettings = {
      className: 'g__color--parking',
      insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_radar.svg`),
    };
    const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);

    return iconHtml;
  };
}
